import React from 'react';
import styles from './HomePage.module.css';
import { Button} from '@mantine/core';
import {ReactComponent as RecipesIcon } from '../../assets/icons/RecipesIcon.svg'
import {ReactComponent as CategoriesIcon } from '../../assets/icons/CategoriesIcon.svg'
import {ReactComponent as SorterIcon } from '../../assets/icons/SorterIcon.svg'
import {ReactComponent as SortingIcon } from '../../assets/icons/SortingIcon.svg'
import {ReactComponent as ModelsIcon } from '../../assets/icons/ModelsIcon.svg'
import { useNavigate } from 'react-router-dom';

//()=>navigate('/categories')  "#62929E"

const HomePage = () =>{
    const navigate = useNavigate();

    const RecipesIcon_ = <RecipesIcon width={19} height={19}>  </RecipesIcon>
    const CategoriesIcon_ = <CategoriesIcon> width={19} height={19}    </CategoriesIcon>
    const OperationsIcon_ = <SortingIcon>  width={19} height={19}</SortingIcon>
    const SorterIcon_ = <SorterIcon> width={19} height={19} </SorterIcon>
    const ModelsIcon_ = <ModelsIcon> width={19} height={19} </ModelsIcon>
    return(
    <div>
        <div className={styles.Header}>
            <h2 className={styles.Title}>Home</h2>
            <p className={styles.Text}>Welcome to Wastex Medusa - textile waste sorting engines</p>
        </div>
        <div className={styles.ButtonWrapper}>
            <Button className ={styles.RecipesButton} onClick={()=>navigate('/recipes')}leftSection={RecipesIcon_} variant="filled" color="#474973" radius="xl">Recipes</Button>
            <Button className ={styles.CategoriesButton} onClick={()=>{navigate('/categories')}} leftSection={CategoriesIcon_} variant="filled" color="#62929E" radius="xl">Categories</Button>
        </div>
        <div className={styles.ButtonWrapper}>
            <Button className ={styles.SortingOperationsButton} onClick={()=>navigate('/operations')}leftSection={OperationsIcon_} variant="filled" color="#A61C3C" radius="xl">SortingOperations</Button>
            <Button className ={styles.SorterButton} onClick={()=>navigate('/sorter')} variant="filled"leftSection={SorterIcon_} color="#FFC759" radius="xl">Sorters</Button>
        </div>
        <div className={styles.ButtonWrapper}>
            <Button className ={styles.ModelsButton} onClick={()=>navigate('/models')}leftSection={ModelsIcon_} variant="filled" color="#E49273" radius="xl">Models</Button>
        </div>

        
    </div>
    
    
    );
}

export default HomePage